module.exports = __webpack_public_path__ + "img/yenisafak.55248f64.png";